import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ShowPointIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Gaussian splat point - ellipse with gradient-like appearance */}
      {/* Core point (filled) */}
      <ellipse cx="12" cy="12" rx="3" ry="2" fill={color} />
      {/* Middle ring */}
      <ellipse cx="12" cy="12" rx="5" ry="3.5" stroke={color} strokeWidth={strokeWidth} fill="none" opacity="0.7" />
      {/* Outer ring (fading) */}
      <ellipse cx="12" cy="12" rx="8" ry="5.5" stroke={color} strokeWidth={strokeWidth} fill="none" opacity="0.3" />
    </BaseIcon>
  ),
);

ShowPointIcon.displayName = 'ShowPointIcon';
